import React, { useEffect, useState } from "react";
import MyTable from "../dataTable";
import { toReadableDate } from "../../utils/utilityFunctions";
import Spinner from "../../utils/spinner";
import VoyageService from "../../services/voyageService";

export default function FuelUsageTableComponent({ fuelConsumptionHistory, voyagePlanningId }) {
	const [tableData, setTableData] = useState(null);
	const [initializing, setInit] = useState(true);
	



	const headerList = [
		{
			Header: "Log Date",
			accessor: "DateConsumed",
		},
		{
			Header: "Quantity ( in liters )",
			accessor: "Quantity",
		},
	];

	

	useEffect(async () => {
		setInit(false);
		
	}, [fuelConsumptionHistory]);

	

	return (
		<div
			className="small-scrollbar"
			style={{
				overflow: "auto",
				boxShadow: "rgb(221, 221, 221) 2px 2px 5px 0.1px",
				maxHeight: 400
			}}>
			{initializing && <Spinner />}
			{!initializing && (
				<MyTable
					columns={headerList}
					cssArray={["font-weight-500", "", "", "text-center"]}
					data={fuelConsumptionHistory || []}
					disablePageSize={true}
					enableSearch={false}
					emptyMessage="No Consumption record"
				/>
			)}
		</div>
	);
}
